
import { createAction } from 'redux-actions'
import {
  UPDATE_DISPLAY_CCB_CARD_ONLY_DIALOG,
  UPDATE_FLOOR,
} from '../../constants/actionType'

const updateDisplayCCBCardOnlyDialogAction = createAction(UPDATE_DISPLAY_CCB_CARD_ONLY_DIALOG)
const updateFloorAction = createAction(UPDATE_FLOOR)

export const updateDisplayCCBCardOnlyDialog = (bool) => (dispatch, getState) => {
  dispatch(updateDisplayCCBCardOnlyDialogAction({ display: bool }))
}

export const updateFloor = (string) => (dispatch, getState) => {
  dispatch(updateFloorAction({ floor: string }))
}



// WEBPACK FOOTER //
// ./src/actions/components/campaign.js